import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import removeEmpty from '@/utils/removeEmpty';

import type {
  ChoiceFiltersState,
  ChoiceOptionsState,
  ChoiceState,
  FiltersPayload,
  HistoryFiltersState,
  HistoryPayload,
} from './types';

const filtersInitialState: ChoiceFiltersState = {};

const historyInitialState: HistoryFiltersState = [];

const optionsInitialState: ChoiceOptionsState = {
  pageNum: 0,
  pageSize: 12,
  sort: ['price'],
};

const initialState: ChoiceState = {
  filters: filtersInitialState,
  history: historyInitialState,
  options: optionsInitialState,
  showFilters: true,
};

export const choiceSlice = createSlice({
  name: 'choice',
  initialState,
  reducers: {
    setPageNum: (state, action: PayloadAction<number>) => ({
      ...state,
      options: {
        ...state.options,
        pageNum: action.payload,
      },
    }),
    setPageSize: (state, action: PayloadAction<number>) => ({
      ...state,
      options: {
        ...state.options,
        pageSize: action.payload,
        pageNum: 0,
      },
    }),
    setSort: (state, action: PayloadAction<string[]>) => ({
      ...state,
      options: {
        ...state.options,
        sort: action.payload,
        pageNum: 0,
      },
    }),
    setFilters: (state, action: PayloadAction<FiltersPayload>) => ({
      ...state,
      filters: removeEmpty({
        ...state.filters,
        ...action.payload,
      }),
      options: {
        ...state.options,
        pageNum: 0,
      },
    }),
    resetFilters: state => ({
      ...state,
      filters: filtersInitialState,
      options: {
        ...state.options,
        pageNum: 0,
      },
    }),
    setHistory: (state, action: PayloadAction<HistoryPayload>) => ({
      ...state,
      history: action.payload,
    }),
    resetHistory: state => ({
      ...state,
      history: historyInitialState,
    }),
    toggleFilters: state => ({
      ...state,
      showFilters: !state.showFilters,
    }),
  },
});

export default choiceSlice.reducer;
